import { useSelector } from 'react-redux';
import userMenu from './user_menu';

// Une fois la ligue terminée (archivée), le joueur n'a plus accès qu'à l'accueil et au profil.
const ARCHIVED_MENU_PATHS = ['/accueil', '/profil'];

export const archivedUserMenu = userMenu.filter(({ path }) => ARCHIVED_MENU_PATHS.includes(path));

// Menu élève à afficher selon l'état de sa ligue (consommé par Navbarfooter, DesktopSidebar et Drawer).
const useUserMenu = () => {
    const leagueArchived = useSelector((state) => state.auth.user?.league_archived);
    return leagueArchived ? archivedUserMenu : userMenu;
};

export default useUserMenu;
